moduleViewApp.controller('collaboratorsSetCtrl', ['$scope', '$routeParams', 'SetsResource', 'SetCollaboratorsResource', 'SiteNavigationService', ($scope, $routeParams, SetsResource, SetCollaboratorsResource, SiteNavigationService) ->
  #debug
  window.debug = window.debug || {}
  window.debug["collaboratorsSetCtrl"] = $scope

  SetsResource.get { id: $routeParams.set_id }
  , (result) ->
    $scope.dirty = false
    $scope.set = result.response
    SiteNavigationService.setContext($scope.set, 'set')
  , (error) ->
    console.error error

  SetCollaboratorsResource.query { set_id: $routeParams.set_id }
  , (result) ->
    $scope.collaborators = result.response
  , (error) ->
    console.error error

  _.assignIn $scope,
    invite_emails : []
    collaborators: []
    cancelPath: Packs.iKnowRoutes.v2_create_set_path($routeParams.set_id)
    defaultUserImage: angular.element("#set-create--container").data("defaultUserImage")
    dirty: true

    addInvite: ->
      SetCollaboratorsResource.create { }, { email: $scope.email, 'set_ids': [$scope.set.id] }
        , (success) ->
          $scope.collaborators = $scope.collaborators.concat(success.response)
          $scope.email = ""

    removeInvite: (index) ->
      $scope.invite_emails.splice(index, 1)

    removeCollaborator: (collaborator) ->
      SetCollaboratorsResource.delete { 'set_ids[]': [$routeParams.set_id], user_id: collaborator.user_id }
      $scope.collaborators = _.filter($scope.collaborators, (c) ->
        return c.user_id != collaborator.user_id
      )
])
